import React from "react";

function View(props) {
  return (
    <div id="top" className="container cid-ugMsAd49dq">
      <div className="mbr-section-head mb-5">
        <h4 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
          <strong className="heading-border1">Connect With Us</strong>
        </h4>
      </div>

      <div className="row justify-content-center">
        <div className="col-lg-12">
          <div className="mbr-section-subtitle mbr-fonts-style mt-0 mb-4 display-7">
            <div className="row">
              <div className="col-12 col-md-6 col-lg-6 icon-design">
                <div className="col-12 d-flex">
                  <i className="fa fa-home home-icon  home_icon" style={{ marginRight: '10px' }} />
                  <ul className="list-unstyled">
                    <li>Corporate Office :</li>
                    <li>17, BDA Colony, E-8, Ishwar Nagar, Bhopal – 462039 (M.P.) INDIA</li>
                    <br />
                    <li>Reg. Office :</li>
                    <li>507, BDA Complex, 7 No. Bus Stop, Shivaji Nagar Bhopal - 462016 (M. P.) INDIA</li>
                  </ul>
                </div>
                <div className="col-12 d-flex">
                  <i className="fa fa-clock-o" style={{ marginRight: '10px' }} />
                  <ul className="list-unstyled">
                    <li>
                      Monday-Friday <br />
                      10:00 AM - 07:00 PM
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="col-sm-12 col-md-6 col-lg-12 d-flex flex-column flex-md-row icon-design">
                  <i className="fa fa-phone" style={{ marginRight: '10px' }} />
                  <ul className="list-unstyled">
                    <li>Support:- <span className="d-block d-sm-inline">+91-755-4232127, +91-755-2767785</span></li>
                    <li>Sale:- <span className="d-block d-sm-inline">+91‑7694009762, +91‑7694009756, <br></br>+91-7694009752</span></li>
                  </ul>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-12 d-flex flex-column flex-md-row icon-design">
                  <i className="fa fa-envelope" style={{ marginRight: '10px' }} />
                  <ul className="list-unstyled text-justify">
                    <li>info@itscglobal.com, sales@itscglobal.com</li>


                  </ul>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-12 d-flex flex-column flex-md-row icon-design">
                  <i className="fa fa-life-ring" style={{ marginRight: '10px' }} />
                  <ul className="list-unstyled text-justify">
                    <li>support@itscglobal.com</li>
                  </ul>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-12 d-flex flex-column flex-md-row icon-design display-7">
                  <i className="fa fa-link" style={{ marginRight: '10px' }} />
                  <ul className="list-unstyled text-justify d-flex flex-column flex-md-row">
                    <li>
                      <a href="#" className="text-white">
                        Home
                      </a>
                    </li>
                    <li>
                      <a href="#article12-l" className="text-white">
                        About Us
                      </a>
                    </li>
                    <li>
                      <a href="#contact-form-3-ugMsAd4paT" className="text-white">
                        Contact
                      </a>
                    </li>
                    <li>
                      <a href="#faq-1-ugMsAd4ZPC" className="text-white">
                        FAQ
                      </a>
                    </li>
                    <li>
                      <a href="#pricing04-o" className="text-white">
                        Pricing
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="col-lg-12 card-design2">
          <div className="google-map" style={{ height: "20rem" }}>
            <iframe title="ITSC Technologies Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3667.3504777854223!2d77.43594657393726!3d23.19389467905405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ec7e34285cf7d19%3A0x14f64dee452ba2c3!2sITSC%20TECHNOLOGIES%20PVT%20LTD!5e0!3m2!1sen!2sus!4v1763621913848!5m2!1sen!2sus" ></iframe>
          </div>
        </div>
      </div>

      <hr className="line-header" />

      <div className="row">
        <div className="col-12">
          <div className="social-row">
            <div className="soc-item">
              <a
                href="https://www.facebook.com/itsctechnologies/"
                target="_blank"
              >
                <span className="mbr-iconfont socicon socicon-facebook display-7" />
              </a>
            </div>
            <div className="soc-item">
              <a
                href="https://x.com/i/flow/login?redirect_after_login=%2FITSCGroup"
                target="_blank"
              >
                <span className="mbr-iconfont socicon-twitter" />
              </a>
            </div>

            <div className="soc-item">
              <a
                href="https://in.linkedin.com/company/itsc-technologies-private-limited"
                target="_blank"
              >
                <span className="mbr-iconfont socicon socicon-linkedin" />
              </a>
            </div>
          </div>
        </div>

        <div className="col-12 mt-3 footer">
          <p className="mbr-fonts-style copyright display-7">
            © 2006. All Rights Reserved. <br /> Designed & Developed by{" "}
            <a
              style={{
                color: "white",
                fontSize: "1.2rem",
                borderBottom: "1px solid white",
              }}
              href="https://itscglobal.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              ITSC Technologies (P) Ltd.
            </a>
          </p>
        </div>
      </div>

      <a
        href="#top"
        className="back-to-top d-flex align-items-center justify-content-center active"
      >
        <i className="fa fa-angle-double-up" style={{ fontSize: "2rem" }} />
      </a>
    </div>
  );
}

export default View;
